/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getGuide, getDealerInfo } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
// import Helpers from "util/helpers";
import OrganisationChartCard from "components/OrganisationChartCard";

class OrganisationChart extends Component {
  state = {
    guideFetched: false,
    nodes: [],
    nodesBuiltStatus: "initial",
    selectedManager: null,
  };

  componentDidMount() {
    if (!this.props.dealerInfo) {
      this.fetchDealerInfo();
    } else {
      this.onDealerFetchSuccess();
    }

    if (this.props.guide.data.length === 0) {
      this.props.getGuide(
        5000,
        this.onGuideFetchBegin,
        this.onGuideFetchSuccess,
        this.onGuideFetchError
      );
    } else this.onGuideFetchSuccess();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.dealerInfo &&
      this.props.guide.data?.length > 0 &&
      this.state.nodesBuiltStatus === "initial"
    ) {
      this.buildNodes();
    }
    if (this.state.nodes.length > 0) {
      this.props.onProcessEnd();
    }
  }

  fetchDealerInfo = () => {
    this.props.getDealerInfo(
      this.onDealerFetchBegin,
      this.onDealerFetchSuccess,
      this.onDealerFetchError
    );
  };

  onDealerFetchSuccess = () => { };

  onDealerFetchError = (err) => {
    this.props.onProcessEnd();
  };

  onDealerFetchBegin = () => {
    this.props.onProcessBegin();
  };

  onGuideFetchBegin = () => {
    this.props.onProcessBegin();
  };

  onGuideFetchError = (err) => {
    this.props.onProcessEnd();
  };

  onGuideFetchSuccess = () => {
    this.setState({
      guideFetched: true,
    });
  };

  getContact = (cid) => {
    let result = null;
    const contact = this.props.guide.data.find((c) => c.id === cid);
    if (contact) {
      result = { ...contact };
    }

    return result;
  };

  getFullContact = (cid) => {
    return this.props.guide.data.find((c) => c.id === cid);
  };

  getReporters = (data, mgrId) => {
    let reporters = data
      .filter((e) => e.reportManager !== null)
      .filter((e) => e.reportManager.id === mgrId);

    return reporters;
  };

  getNode = (nodeId) => {
    if (nodeId === 0) {
      this.buildNodes();
      return this.state.nodes;
    }
    let contact = this.props.guide.data.find((c) => c.id === nodeId);
    let node = {
      id: nodeId,
      name: contact.fullname,
      managerId: contact.reportManager ? contact.reportManager.id : 0,
      nodes: this.getNodes(this.getReporters(this.props.guide.data, nodeId)),
    };

    return node;
  };

  getNodes = (reporters) => {
    let nodes = [];
    reporters.forEach((e) => {
      let node = {
        id: e.id,
        name: e.fullname,
        managerId: e.reportManager ? e.reportManager.id : null,
        nodes: this.getNodes(this.getReporters(this.props.guide.data, e.id)),
      };

      nodes.push(node);
    });
    return nodes;
  };

  buildNodes = () => {
    this.setState({ nodesBuiltStatus: "building" });

    let nodes = [];
    this.props.guide.data
      .filter((e) => {
        return e.isOtosanContact === false;
      })
      .filter((e) => {
        return e.reportManager === null;
      })
      .forEach((tlm) => {
        let node = {
          id: tlm.id,
          name: tlm.fullname,
          managerId: 0,
          nodes: this.getNodes(
            this.getReporters(this.props.guide.data, tlm.id)
          ),
        };
        nodes.push(node);
      });

    const sorted = nodes.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })

    // add root (çünkü genel müdür?)
    const rootNode = {
      id: 0,
      name: this.props.dealerInfo.name, // veya bayi ismi?
      managerId: null,
      nodes: [...sorted],
    };

    this.setState({
      nodes: rootNode,
      selectedManager: rootNode,
      nodesBuiltStatus: "built",
    });
  };

  handleSelectManager = (node) => {
    this.setState({
      selectedManager: node,
    });
  };

  renderRoot = (rootNode) => {
    const rootContact = this.getContact(rootNode.id);

    if (rootNode.managerId === null) {
      return (
        <div className="fordOrgSchemaInner" data-child="1">
          <div className="fordOrgSchemaProfilImgArea">
            <div
              className="fordOrgSchemaProfilImg"
              style={{
                backgroundImage: "url('img/ford-gelisim-akademisi-avatar.svg')",
              }}
            ></div>
          </div>
          <div className="fordOrgSchemaProfilTextArea text-center">
            <div className="fordOrgSchemaName">{rootNode.name}</div>
            <div className="fordOrgSchemaTitle"> </div>
          </div>
          <div className="fordOrgSchemaDownMenu">
            <a href="#">
              <span className="iconmford fo-icon-remove-circle-outline"></span>
            </a>
          </div>
        </div>
      );
    } else {
      return (
        <div className="fordOrgSchemaUpLevel">
          <div className="fordOrgCardInner">
            <div className="fordOrgCardProfilImgArea">
              <a
                onClick={() =>
                  this.handleSelectManager(this.getNode(rootNode.managerId))
                }
              >
                <span className="icon-icon-table-dropdown-up"></span>
              </a>
            </div>
            <div className="fordOrgCardProfilTextArea">
              <div className="fordOrgCardName">{rootNode.name}</div>
              <div className="fordOrgCardTitle">
                {rootContact.department} / {rootContact.position}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  renderChart = () => {
    if (this.state.nodes.length === 0) {
      return this.props.spinner;
    }

    const rootNode = this.state.selectedManager;

    return (
      <>
        <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
            <ul className="fgaBreadcrumb">
              <li>
                <a href="/" style={{ verticalAlign: "middle" }}>
                  <span className="iconmford fo-icon-home"></span>
                </a>

              </li>
              <li>
                <a href="#" style={{ verticalAlign: "middle" }}>
                  <Trans desc="Şirket Bilgileri">10024</Trans>
                </a>
              </li>
              <li className="active">
                <Trans desc="Organizasyon Şeması">10030</Trans>
              </li>
            </ul>
          </div>
        </div>
        <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
            <div className="profilBaslik">
              <Trans desc="Organizasyon Şeması">10030</Trans>
            </div>
          </div>
        </div>
        <div className="row py-4" data-groupid="1">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 fordOrgSchemaParentArea text-center">
            {this.renderRoot(rootNode)}
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="fordOrgSchemaChildArea text-center">
              {rootNode.nodes.map((node) => {
                return (
                  <OrganisationChartCard
                    key={node.id}
                    contact={this.getContact(node.id)}
                    getContact={this.getContact}
                    onSelect={() => this.handleSelectManager(node)}
                    hasChildren={node.nodes.length > 0 ? true : false}
                  />
                );
              })}
              {/* className : withoutChild */}
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        <div className="container">{this.renderChart()}</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    guide: state.guide,
    dealerInfo: state.dealerInfo.data.data,
  };
};

export default connect(mapStateToProps, { getGuide, showModal, getDealerInfo })(
  requireAuth(containsLongRunningProcess(OrganisationChart))
);
